import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/Menu.ts

var Menu_exports = {};

__export(Menu_exports, {
  handleParseMenuUrl: function handleParseMenuUrl() {
    return _handleParseMenuUrl;
  },
  menuPattern: function menuPattern() {
    return _menuPattern;
  },
  renderMenuText: function renderMenuText() {
    return _renderMenuText;
  }
});

import * as R from "ramda";
var _menuPattern = /(menu?:\/\/)[-a-zA-Z0-9@:%._\+~#=]{1,256}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=\/\u4e00-\u9fa5|\uFF00-\uFFEF]*)/i;

var _handleParseMenuUrl = function _handleParseMenuUrl(url) {
  return R.pipe(R.split("menu://"), function (items) {
    return R.nth(1, items) || "";
  }, R.split("&"), R.map(R.split("=")), function (items) {
    return R.fromPairs(items.map(function (item) {
      return [item[0], item[1]];
    }));
  })(url);
};

var _renderMenuText = function _renderMenuText(text, t) {
  var parseUrl = _handleParseMenuUrl(text);

  var type = parseUrl.type,
      title = parseUrl.title;

  switch (type) {
    case "rank":
      return title || t("group:rank");

    case "social":
      return title || t("group:social");

    case "socialTag":
      return title || t("group:tag");

    case "survey":
      return title || t("group:survey");

    case "surveyForm":
      return title || t("group:survey");

    default:
      return title || text;
  }
};

export { _menuPattern as menuPattern, _handleParseMenuUrl as handleParseMenuUrl, _renderMenuText as renderMenuText, Menu_exports };